<template>
  <div class="form-check p-0 mbr-checkbox">
    <input
      :style="inputStyle"
      :id="id"
      class="form-check-input mbr-checkbox__input"
      type="checkbox"
      :name="name"
      :value="modelValue"
      :checked="checked"
      @input="$emit('update:modelValue', $event.target.checked)"
    />
    <label :for="id" class="custom-control-label mbr-checkbox__label">
      <slot name="label" />
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialCheckbox",
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
    checked: {
      type: Boolean,
      required: true,
    },
    inputStyle: {
      type: Object
    }
  },
};
</script>
<style scoped>
/* !important outranks the #495057 checked border forced in custom.css */
.form-check.mbr-checkbox:not(.form-switch) .form-check-input.mbr-checkbox__input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-top: 0;
  vertical-align: middle;
  background: var(--mbr-color-surface);
  border: 1.5px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-sm);
  cursor: pointer;
}

.form-check.mbr-checkbox:not(.form-switch) .form-check-input.mbr-checkbox__input[type="checkbox"]:checked {
  background: var(--mbr-color-label);
  border-color: var(--mbr-color-label) !important;
}

/* CSS-drawn tick instead of the Material FontAwesome glyph, which renders as tofu here */
.form-check.mbr-checkbox:not(.form-switch) .form-check-input.mbr-checkbox__input[type="checkbox"]:after {
  content: "";
  top: 45%;
  left: 50%;
  width: 6px;
  height: 11px;
  border: solid var(--mbr-color-surface);
  border-width: 0 2px 2px 0;
  transform: translate(-50%, -50%) rotate(45deg);
}

.form-check.mbr-checkbox:not(.form-switch) .form-check-input.mbr-checkbox__input[type="checkbox"]:focus {
  box-shadow: none;
}

.form-check.mbr-checkbox:not(.form-switch) .form-check-input.mbr-checkbox__input[type="checkbox"]:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-checkbox__label {
  margin-left: var(--mbr-space-sm);
  vertical-align: middle;
  font-family: var(--mbr-font-body);
  font-size: var(--mbr-label-md-size);
  font-weight: 500;
  color: var(--mbr-color-ink-secondary);
}
</style>
